import React from "react";

import { Tooltip, Box, Stack, Text } from "@chakra-ui/react";

import useTranslations from "../../../../hooks/useTranslations";

import { AnswerReviewProps } from "./types/AnswerReviewProps";
import TextareaLikeBox from "./TextareaLikeBox";

const AnswerCommentReview: React.FC<AnswerReviewProps> = React.memo(
  ({ answer, path }) => {
    const t = useTranslations();

    return (
      <Stack spacing="2">
        <Text fontSize="md" fontWeight="medium" color="gray.600">
          {t("reports.shared.comment")}
        </Text>
        <Tooltip
          textAlign="center"
          placement="bottom"
          label={t("reports.shared.immutableComment") as string}
        >
          <Box maxWidth="2xl" w="full">
            <Box
              as="label"
              htmlFor={`${path}.answer.${answer.id}.comment`}
              srOnly
            >
              {t("reports.shared.commentByARIA", { name: answer.user?.name })}
            </Box>
            <TextareaLikeBox
              id={`${path}.answer.${answer.id}.comment`}
              answer={answer}
              value={answer?.value?.comment}
            />
          </Box>
        </Tooltip>
      </Stack>
    );
  }
);

export default AnswerCommentReview;
